import { useCallback } from 'react';
import { FleetMap, type MapTech, type MapView } from '@/components/map/FleetMap';
import type { ScheduleJob, ScheduleLane } from './scheduleModel';

interface ScheduleMapProps {
  jobs: ScheduleJob[];
  lanes: ScheduleLane[];
  selectedJobId: string | null;
  onOpenJob: (id: string) => void;
  /** Technicians to draw (today only; empty on other days or when tracking is off). */
  techs?: MapTech[];
  fallback: MapView;
  /** The day shown: the map fits its jobs again when it changes. */
  day: string;
}

/** The Schedule board's day map: the shared FleetMap with lane colours and the job sheet on click. */
export function ScheduleMap({ jobs, lanes, selectedJobId, onOpenJob, techs, fallback, day }: ScheduleMapProps) {
  const colourOf = useCallback(
    (techId: string | null) =>
      (techId ? lanes.find((l) => l.techId === techId)?.colour : undefined) ?? 'hsl(var(--muted-foreground))',
    [lanes],
  );

  return (
    <FleetMap
      jobs={jobs}
      colourOf={colourOf}
      techs={techs}
      selectedJobId={selectedJobId}
      onSelectJob={onOpenJob}
      fallback={fallback}
      fitKey={day}
    />
  );
}
